<template>
    <rkm-modal
        :buttons="['cancel']"
        extra-large
        ref="RkmModal"
        title="Histórico de atendimento"
    >


        <rkm-tabs>
            <rkm-tab title="Histórico">
                <BoxHistorico :data="data" />
            </rkm-tab>

            <rkm-tab title="Histórico - Santa Casa" v-if="data.form.exibeHistoricoErpsaude">
                <BoxHistoricoHospitalSantaCasa :data="data" />
            </rkm-tab>
        </rkm-tabs>
    </rkm-modal>
</template>

<script>
// Components.
import BoxHistorico from '@/components/ambulatorio/atendimento/components/historico/Index.vue'
import BoxHistoricoHospitalSantaCasa from '@/components/ambulatorio/atendimento/components/historico-hospital-santa-casa/Index'

export default {
    components: {BoxHistorico, BoxHistoricoHospitalSantaCasa},
    methods: {
        open() {
            this.$refs.RkmModal.show()
        }
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>
